import {
    GET_ALL_PROGRAM_BEGIN,
    GET_ALL_PROGRAM_SUCCESS,
    GET_ALL_PROGRAM_ERROR,
    ADD_PROGRAM_BEGIN,
    ADD_PROGRAM_SUCCESS,
    ADD_PROGRAM_ERROR,
    GET_PROGRAM_BEGIN,
    GET_PROGRAM_ERROR,
    GET_PROGRAM_SUCCESS,
    UPDATE_PROGRAM_BEGIN,
    UPDATE_PROGRAM_SUCCESS,
    UPDATE_PROGRAM_ERROR,
    DELETE_PROGRAM_BEGIN,
    DELETE_PROGRAM_SUCCESS,
    DELETE_PROGRAM_ERROR,
  } from "./constants";
  
  const initState = {
    list: [],
    loading: false,
    error: null,
  };
  
  const ProgramReducer = (state = initState, action) => {
    const { type, data, error } = action;
    switch (type) {
      case GET_ALL_PROGRAM_BEGIN:
        return {
          ...state,
          loading: true,
        };
      case GET_ALL_PROGRAM_SUCCESS:
        return {
          ...state,
          list: data,
          loading: false,
        };
      case GET_ALL_PROGRAM_ERROR:
        return {
          ...state,
          error,
          loading: false,
        };
      case ADD_PROGRAM_BEGIN:
        return {
          ...state,
          loading: true,
        };
      case ADD_PROGRAM_SUCCESS:
        return {
          ...state,
          loading: false,
          list: [...state.list, data],
        };
      case ADD_PROGRAM_ERROR:
        return {
          ...state,
          error,
          loading: false,
        };
      case GET_PROGRAM_BEGIN:
        return {
          ...state,
          loading: true,
          ProgramData: "",
        };
      case GET_PROGRAM_SUCCESS:
        return {
          ...state,
          loading: false,
          ProgramData: data,
        };
      case GET_PROGRAM_ERROR:
        return {
          ...state,
          error,
          loading: false,
        };
      case UPDATE_PROGRAM_BEGIN:
        return {
          ...state,
          loading: true,
        };
      case UPDATE_PROGRAM_SUCCESS:
        return {
          ...state,
          loading: false,
          list: state.list.map((ele) => {
            if (ele.id === data.id) {
              return { ...data };
            } else return ele;
          }),
        };
      case UPDATE_PROGRAM_ERROR:
        return {
          ...state,
          error,
          loading: false,
        };
      case DELETE_PROGRAM_BEGIN:
        return {
          ...state,
          loading: true,
        };
      case DELETE_PROGRAM_SUCCESS:
        return {
          ...state,
          loading: false,
          list: state.list.filter((ele) => ele.id !== data.id),
        };
      case DELETE_PROGRAM_ERROR:
        return {
          ...state,
          error,
          loading: false,
        };
      default:
        return state;
    }
  };
  
  export default ProgramReducer;
  